module.exports = __webpack_public_path__ + "img/duoduan.39d53cf6.png";